import { combineReducers } from 'redux';
import certManagementSlice from '../slice/certManagementSlice';

const featuresReducer = combineReducers({
    certManagement: certManagementSlice,
});

export default featuresReducer;
